export interface RegisterAppCloseEntity {
  closingApps: Record<string, { lastUpdate: string }>;
}

export function initRegisterAppCloseEntity(): RegisterAppCloseEntity {
  return {
    closingApps: {},
  };
}

export type RegisterAppCloseType = 'registerAppClose';
